// src/pages/About.js
import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import '../styles.css';

export default function About() {
  return (
    <>
      <PublicHeader />
      <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>About Hot Setup</h1>
        <p style={{ textAlign: 'center', color: '#666', marginBottom: '50px', fontSize: '1.1rem' }}>
          Built by motorsport professionals, for motorsport enthusiasts
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
          {/* Creator Section */}
          <div style={{ textAlign: 'center' }}>
            <img
              src="/images/sasha-anis.jpg"
              alt="Sasha Anis"
              style={{
                width: '200px',
                height: '200px',
                borderRadius: '50%',
                objectFit: 'cover',
                marginBottom: '20px',
                border: '4px solid #007bff'
              }}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h2>Sasha Anis</h2>
            <p style={{ fontSize: '1.1rem', color: '#666', marginBottom: '30px' }}>
              Founder & Creator of Hot Setup
            </p>
          </div>

          {/* Background Story */}
          <div>
            <h3>The Story Behind Hot Setup</h3>
            <p>
              Hot Setup was born from frustration. As someone who's spent over 20 years in professional motorsport,
              I've seen countless racers struggle with the same problem: tracking vehicle setup changes between sessions.
              Pen and paper methods, spreadsheets, and basic apps just weren't cutting it for serious track work.
            </p>
            <p>
              After winning championships as both a driver and crew chief across North American racing series,
              I knew there had to be a better way. That's why I built Hot Setup – a tool that combines my experience
              in vehicle dynamics, data logging, and motorsport electronics into an intuitive app that actually
              helps racers go faster.
            </p>
          </div>

          {/* Experience Section */}
          <div>
            <h3>Motorsport Experience</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '20px' }}>
              <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
                <h4>🏆 Racing Career</h4>
                <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
                  <li>Multiple championships as driver and crew chief</li>
                  <li>Professional racing series across North America</li>
                  <li>Track record setting with hybrid-electric KERS Kels</li>
                  <li>Experience with both ICE and electric vehicles</li>
                </ul>
              </div>

              <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
                <h4>🔧 Technical Expertise</h4>
                <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
                  <li>Vehicle dynamics and suspension setup</li>
                  <li>Data logging and analysis systems</li>
                  <li>Motorsport electronics and calibration</li>
                  <li>Engine performance and component design</li>
                </ul>
              </div>

              <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
                <h4>🏭 Mountain Pass Performance</h4>
                <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
                  <li>Founded MPP in 2017</li>
                  <li>Leading Tesla performance aftermarket supplier</li>
                  <li>Built record-setting EV conversions (Blue Lightning)</li>
                  <li>Developed hybrid racecars (KERS Kels)</li>
                </ul>
              </div>

              <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px' }}>
                <h4>📊 Motec & VBOX Canada</h4>
                <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
                  <li>Deep involvement with Motec data acquisition systems</li>
                  <li>VBOX GPS timing and data logging expertise</li>
                  <li>Integration of advanced telemetry solutions</li>
                  <li>Professional racing data analysis and optimization</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Why Hot Setup */}
          <div>
            <h3>Why I Built Hot Setup</h3>
            <p>
              Every racer knows that small setup changes can make a noticeable difference. But without proper tracking,
              it's easy to lose track of what worked. I've seen teams spend hours guessing at setups because
              they lost track of what they changed last time - or worse, making assumptions based on bad data. 
            </p>
            <p>
              Hot Setup solves this by giving you a complete picture of your vehicle's setup history. Compare any
              two setups side-by-side, track tire wear, log weather conditions, and never lose another setup again.
              It's the tool I wish I had when I was starting out – and it's the tool professional teams use today.
            </p>
          </div>

          {/* Mission */}
          <div style={{ background: 'linear-gradient(135deg, #007bff 0%, #28a745 100%)', color: 'white', padding: '30px', borderRadius: '12px', textAlign: 'center' }}>
            <h3>Our Mission</h3>
            <blockquote style={{ fontSize: '1.2rem', fontStyle: 'italic', margin: '0 0 15px 0', borderLeft: '4px solid white', paddingLeft: '20px' }}>
              "You can't fix what you can't measure"
            </blockquote>
            <p style={{ fontSize: '1.1rem', margin: '0 0 15px 0' }}>
              But beyond that - the only thing worse than no data is bad data. That's why we built Hot Setup.
            </p>
            <p style={{ fontSize: '1rem', margin: '0' }}>
              We're bringing easy, reliable setup tracking and data management to every motorsport enthusiast,
              from track-day warriors to professional teams. No more guesswork, no more lost setups – just
              clear insights that help you go faster.
            </p>
          </div>

          {/* Contact */}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <h3>Questions or Feedback?</h3>
            <p>
              I'd love to hear from you. Whether you're a seasoned racer or just getting started,
              your input helps make Hot Setup better for everyone.
            </p>
            <a
              href="mailto:hello@hotsetup.app"
              style={{
                display: 'inline-block',
                background: '#007bff',
                color: 'white',
                padding: '12px 24px',
                textDecoration: 'none',
                borderRadius: '6px',
                fontWeight: 'bold',
                marginTop: '10px'
              }}
            >
              Get In Touch →
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}